
import { useRef, useEffect, useState } from "react";
import FrontExpandButton from "../../Buttons/FrontExpandButton";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import Column from "@/Components/Grid/Column";

const collapsedVisibleHeight = 99;
const extendableFromHeight = 280;

const AnimatedAccordion = ({buttonText, expandedButtonText, buttonClassName = '', className = '', children}) => {
    const paramsAccordion = useRef(null);
    const [isOpenedAccordion, setIsOpenedAccordion] = useState(false);
    const [isExpandButtonVisible, setIsExpandButtonVisible] = useState(true);

    const handleParamsAccordion = () => {
        if (paramsAccordion.current) {
            setIsOpenedAccordion(!isOpenedAccordion);
        }
    }

    useEffect(() => {
        if (paramsAccordion.current) {
            const accordionHeight = paramsAccordion.current.scrollHeight;
            
            if (accordionHeight <= extendableFromHeight) {
                setIsExpandButtonVisible(false);
                paramsAccordion.current.style.maxHeight = accordionHeight + 40 + 'px';
                return;
            }

            if (isOpenedAccordion) {
                paramsAccordion.current.style.maxHeight = accordionHeight + 40 + 'px';
            } else {
                paramsAccordion.current.style.maxHeight = collapsedVisibleHeight + 'px';
            }
        }
    }, [isOpenedAccordion, paramsAccordion.current]);

    return (
        <>
            <div className={`transition-all ease-in-out duration-1000 md:overflow-visible overflow-hidden ${className ? className : 'md:!max-h-full max-h-0'}`} ref={paramsAccordion}>
                {children}
            </div>
                <Row>
                    <Column>
                        <div className={`${buttonClassName ? buttonClassName : 'md:hidden mt-5 mb-16 flex justify-center'}`}>
                            {isExpandButtonVisible && (
                                <FrontExpandButton onClick={handleParamsAccordion} expanded={isOpenedAccordion}>
                                    {isOpenedAccordion ? expandedButtonText : buttonText}
                                </FrontExpandButton>
                            )}
                        </div>
                    </Column>
                </Row>
        </>
    )
}

export default AnimatedAccordion;